import { registerClient } from '@/scopes/common/infrastructure/query-client/queryClientsRegistry';
import { QueryClient } from '@tanstack/react-query';

export const searchQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
});

registerClient(searchQueryClient);
